import React from 'react';

import { Button, Card, CardContent, CardHeader, Divider, Stack, Typography } from '@mui/material';

import { useStrategyManage } from '../../hooks/useStrategyManage';
import { ApiKeysDialog } from '../ApiKeysDialog';

type Props = {
  strategyId: string;
  initialFrozen: boolean;
};

export const ManageStrategySection: React.FC<Props> = ({ strategyId, initialFrozen }) => {
  const {
    loading,
    isFrozen,
    apiKeys,
    resetApiKeys,
    onRecalcHistory,
    onRebalance,
    onSendToCs,
    onDownload,
    onFreeze,
    onGetApiKeys,
  } = useStrategyManage(strategyId, initialFrozen);

  return (
    <>
      {apiKeys && <ApiKeysDialog apiKey={apiKeys} onClose={resetApiKeys} />}
      <Card>
        <CardHeader title="Управление стратегией" />
        <Divider />
        <CardContent>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Button variant="contained" onClick={onRecalcHistory} tabIndex={0} aria-label="Пересчитать историю">
              Пересчитать историю
            </Button>
            <Button variant="contained" onClick={onRebalance} tabIndex={0} aria-label="Балансировать">
              Балансировать
            </Button>
            <Button variant="contained" onClick={onSendToCs} tabIndex={0} aria-label="Отправить в CS">
              Отправить в CS
            </Button>
            <Button variant="outlined" onClick={onDownload} tabIndex={0} aria-label="Скачать график доходности">
              Скачать график доходности
            </Button>
            <Button
              variant="contained"
              disabled={loading}
              onClick={onFreeze}
              tabIndex={0}
              aria-label={isFrozen ? 'Разморозить' : 'Заморозить'}
            >
              {isFrozen ? 'Разморозить' : 'Заморозить'}
            </Button>
            <Button variant="contained" onClick={onGetApiKeys} tabIndex={0} aria-label="Получить API Keys">
              Получить API Keys
            </Button>
          </Stack>
          {isFrozen && (
            <Typography color="error" sx={{ mt: 1 }}>
              Заморожена
            </Typography>
          )}
        </CardContent>
      </Card>
    </>
  );
};
